import "../reusable.scss";

import {
  CAlert,
  CButton,
  CCol,
  CForm,
  CFormGroup,
  CInput,
  CLabel,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
} from "@coreui/react";

import CIcon from "@coreui/icons-react";
import { Loading } from "src/reusable/LoadingSpinner";
import LoadingOverlay from "react-loading-overlay-ts";
import PropTypes from "prop-types";

export const DeleteItemModal = (props) => {
  return (
    <CModal
      id={`delete-item-modal-${props.itemName}`}
      data-testid={props.testId}
      show={props.isVisible}
      onClose={() => props.onClose()}
    >
      <CModalHeader>
        <CCol sm="10">
          <h3>{props.modalTitle}</h3>
        </CCol>
        <CCol sm="2" id={`delete-item-modal-col-${props.itemName}`}>
          <CButton
            id={`delete-item-close-button-${props.itemName}`}
            data-testid={`delete-modal-btn-close-${props.itemName}`}
            data-attr="shared:btn:close-delete-modal"
            color="secondary"
            onClick={() => props.onClose()}
            size="sm"
          >
            <CIcon name="cil-x" />
          </CButton>
        </CCol>
      </CModalHeader>
      <LoadingOverlay
        active={props.isDeleteItemLoading}
        spinner={<Loading height={"75em"} width={"75em"} />}
        text="Deleting..."
      >
        {props.deleteItemStatus === "success" ? (
          <CModalBody>
            <span id={`delete-item-success-message-${props.itemName}`}>
              {props.itemName} has been deleted
            </span>
          </CModalBody>
        ) : (
          <>
            <CModalBody>
              {props.errorMessage && (
                <CAlert color="danger" style={{ textAlign: "left" }}>
                  {props.errorMessage}
                </CAlert>
              )}
              <CForm>
                <CFormGroup row>
                  <CAlert
                    color="warning"
                    id={`delete-item-warning-message-1-${props.itemName}`}
                    style={{ textAlign: "left" }}
                  >
                    Are you sure you want to delete{" "}
                    <strong>{props.itemName}</strong>? This action is{" "}
                    <strong>non-reversible</strong>.
                  </CAlert>

                  <CLabel
                    id={`delete-item-modal-instructions-${props.itemName}`}
                    style={{ textAlign: "left", width: "100%" }}
                  >
                    {props.deleteInstructions}
                  </CLabel>

                  <CAlert
                    color="danger"
                    id={`delete-item-modal-dataset-in-folder-count-label-${props.itemName}`}
                    hidden={!props.deleteDatasetsInFolderCountText}
                  >
                    <strong>{props.deleteDatasetsInFolderCountText}</strong>
                  </CAlert>

                  <CInput
                    id={`delete-item-confirm-itemName-input-${props.itemName}`}
                    data-testid={`delete-modal-input-confirm-${props.itemName}`}
                    data-attr="shared:input:confirm-delete-name"
                    type="text"
                    name="name"
                    placeholder="name"
                    value={props.confirmDeleteString}
                    onChange={(e) =>
                      props.setConfirmDeleteString(e.target.value)
                    }
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                      }
                    }}
                  />
                </CFormGroup>
              </CForm>
            </CModalBody>
            <CModalFooter>
              <CCol sm="12" id={`delete-item-modal-col-${props.itemName}`}>
                <CButton
                  id={`delete-item-submit-button-${props.itemName}`}
                  data-testid={`delete-modal-btn-submit-${props.itemName}`}
                  data-attr="shared:btn:submit-delete"
                  color="danger"
                  disabled={props.confirmDeleteString !== props.itemName}
                  onClick={() => props.onSubmit(props.itemId)}
                >
                  {props.buttonTitle}
                </CButton>
              </CCol>
            </CModalFooter>
          </>
        )}
      </LoadingOverlay>
    </CModal>
  );
};

DeleteItemModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  itemName: PropTypes.string,
  itemId: PropTypes.number,
  onSubmit: PropTypes.func.isRequired,
  confirmDeleteString: PropTypes.string.isRequired,
  setConfirmDeleteString: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  deleteItemStatus: PropTypes.string.isRequired,
  isDeleteItemLoading: PropTypes.bool.isRequired,
  modalTitle: PropTypes.string.isRequired,
  deleteInstructions: PropTypes.string.isRequired,
  buttonTitle: PropTypes.string.isRequired,
  deleteDatasetsInFolderCountText: PropTypes.string,
  testId: PropTypes.string,
};
